import initApiClient from './initApiClient';

const apiClient = initApiClient();

export default apiClient;
